<script>
import {defineComponent} from 'vue'
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import RequisiteTable from "@js/components/Sections/Contacts/RequisiteTable.vue";
import {Link} from "@inertiajs/vue3";
import {useCallbackStore} from "@js/store/CallbackStore.js";

export default defineComponent({
    name: "AboutCompanyPage",
    components: {
        Link,
        RequisiteTable,
        Breadcrumbs,
        MobileTopBar,
    },
    setup() {
        const callbackStore = useCallbackStore()
        return {callbackStore}
    },
    data() {
        return {
            facts: [
                {label: 'Основное направление', value: 'Приём и вывоз металлолома'},
                {label: 'Формат работы', value: 'Частные лица и организации'},
                {label: 'Дополнительные услуги', value: 'Погрузка, демонтаж, спецтехника'},
                {label: 'Вывоз металлолома', value: 'Бесплатный'},
            ],

            services: [
                'Приём черного металлолома',
                'Приём цветного металла',
                'Бесплатный вывоз металлолома',
                'Погрузка и организация вывоза',
                'Демонтаж металлоконструкций',
                'Работа с разовыми и регулярными объёмами',
            ],

            advantages: [
                'Работаем с частными клиентами и организациями.',
                'Подбираем подходящий формат вывоза под объём и тип металла.',
                'Организуем выезд транспорта без отдельной оплаты за подачу.',
                'При необходимости подключаем погрузку и спецтехнику.',
                'Сопровождаем клиента от заявки до вывоза металла.',
                'Ориентируемся на понятный и организованный процесс работы.',
            ],

            workflow: [
                {
                    title: 'Приём заявки',
                    text: 'Клиент передаёт информацию о металлоломе, объёме и адресе объекта.'
                },
                {
                    title: 'Уточнение деталей',
                    text: 'Мы уточняем формат работы, условия на объекте и необходимость техники.'
                },
                {
                    title: 'Подбор решения',
                    text: 'Определяем подходящий формат: вывоз, погрузка, контейнер или демонтаж.'
                },
                {
                    title: 'Организация работ',
                    text: 'Согласовываем выезд транспорта и выполняем работы.'
                }
            ]
        }
    }
})
</script>

<template>
    <MobileTopBar/>

    <div class="container mb-5 md:mb-10">

        <Breadcrumbs/>

        <!-- Заголовок -->
        <section class="mb-5 md:mb-8">
            <h1 class="text-2xl md:text-3xl font-semibold mb-5">
                О компании «Вторчермет-1»
            </h1>

            <div class="grid grid-cols-1 xl:grid-cols-[1.2fr_.8fr] gap-5">

                <!-- описание -->
                <div class="border border-gray-200 rounded-2xl p-5 md:p-8">

                    <h2 class="text-lg md:text-xl font-semibold mb-4">
                        Общая информация
                    </h2>

                    <p class="text-gray-700 leading-relaxed mb-4">
                        «Вторчермет-1» — компания, специализирующаяся на приёме и вывозе
                        металлолома. Мы работаем с частными клиентами, предприятиями,
                        строительными объектами и производственными площадками.
                    </p>

                    <p class="text-gray-700 leading-relaxed mb-4">
                        Основная задача компании — организовать понятный и удобный процесс
                        сдачи металла. В зависимости от объёма и условий на объекте мы
                        предлагаем подходящий формат работы: самостоятельную сдачу,
                        бесплатный вывоз, погрузку или демонтаж.
                    </p>

                    <p class="text-gray-700 leading-relaxed">
                        При необходимости используется специализированный транспорт
                        и техника для работы с крупными и сложными объектами.
                    </p>

                </div>

                <!-- факты -->
                <div class="border border-gray-200 rounded-2xl p-5 md:p-8">

                    <h2 class="text-lg md:text-xl font-semibold mb-4">
                        Основные сведения
                    </h2>

                    <div class="divide-y divide-gray-200">

                        <div
                            v-for="item in facts"
                            :key="item.label"
                            class="py-3"
                        >
                            <div class="text-sm text-gray-500 mb-1">
                                {{ item.label }}
                            </div>

                            <div class="font-medium text-gray-900">
                                {{ item.value }}
                            </div>

                        </div>

                    </div>

                </div>

            </div>
        </section>


        <!-- направления -->
        <section class="mb-5 md:mb-8">

            <div class="grid grid-cols-1 xl:grid-cols-2 gap-5">

                <div class="border border-gray-200 rounded-2xl p-5 md:p-8">

                    <h2 class="text-lg md:text-xl font-semibold mb-4">
                        Основные направления деятельности
                    </h2>

                    <ul class="space-y-3">

                        <li
                            v-for="item in services"
                            :key="item"
                            class="flex items-start gap-3"
                        >

                            <span class="mt-2 w-1.5 h-1.5 rounded-full bg-gray-500 shrink-0"></span>

                            <span class="text-gray-700 leading-relaxed">
                                {{ item }}
                            </span>

                        </li>

                    </ul>

                </div>

                <div class="border border-gray-200 rounded-2xl p-5 md:p-8">

                    <h2 class="text-lg md:text-xl font-semibold mb-4">
                        Преимущества работы
                    </h2>

                    <ul class="space-y-3">

                        <li
                            v-for="item in advantages"
                            :key="item"
                            class="flex items-start gap-3"
                        >

                            <span class="mt-2 w-1.5 h-1.5 rounded-full bg-gray-500 shrink-0"></span>

                            <span class="text-gray-700 leading-relaxed">
                                {{ item }}
                            </span>

                        </li>

                    </ul>

                </div>

            </div>

        </section>


        <!-- порядок работы -->
        <section class="mb-5 md:mb-8">

            <div class="border border-gray-200 rounded-2xl p-5 md:p-8">

                <h2 class="text-lg md:text-xl font-semibold mb-5">
                    Порядок взаимодействия
                </h2>

                <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">

                    <div
                        v-for="(item,index) in workflow"
                        :key="item.title"
                        class="border border-gray-200 rounded-xl p-4 bg-white"
                    >

                        <div class="text-sm text-gray-500 mb-2">
                            Этап {{ index + 1 }}
                        </div>

                        <h3 class="font-semibold mb-2">
                            {{ item.title }}
                        </h3>

                        <p class="text-sm text-gray-600 leading-relaxed">
                            {{ item.text }}
                        </p>

                    </div>

                </div>

            </div>

        </section>


        <!-- контакт -->
        <section class="mb-5 md:mb-8">

            <div class="bg-grayBg border border-gray-200 rounded-2xl p-5 md:p-8">

                <div class="grid grid-cols-1 lg:grid-cols-[1fr_auto] gap-4 items-center">

                    <div>

                        <h2 class="text-lg md:text-xl font-semibold mb-2">
                            Связаться с компанией
                        </h2>

                        <p class="text-gray-600 leading-relaxed">
                            Для консультации по сдаче металлолома, организации вывоза
                            или уточнения условий сотрудничества вы можете оставить
                            заявку на обратный звонок.
                        </p>

                    </div>

                    <div class="flex flex-col sm:flex-row gap-3">

                        <button
                            @click.prevent="callbackStore.showBaseCallbackPopup?.({
                                title: 'Обратный звонок',
                                bitrix_title: 'Заказ обратного звонка с сайта Вторчермет-1',
                                })"
                            class="text-center text-black border border-gray-300 bg-white hover:border-gray-400 font-medium rounded-xl px-5 py-3 transition"
                        >
                            Заказать звонок
                        </button>

                        <Link
                            :href="route('howToHandOver')"
                            class="text-center text-black border border-gray-300 bg-white hover:border-gray-400 font-medium rounded-xl px-5 py-3 transition"
                        >
                            Как сдать металл
                        </Link>

                    </div>

                </div>

            </div>

        </section>


        <!-- реквизиты -->
        <section>

            <div class="grid grid-cols-1 xl:grid-cols-[280px_1fr] gap-5 items-start">

                <div class="border border-gray-200 rounded-2xl p-5 md:p-8">

                    <h2 class="text-lg md:text-xl font-semibold mb-3">
                        Реквизиты
                    </h2>

                    <p class="text-sm text-gray-600 leading-relaxed">
                        Основные реквизиты компании «Вторчермет-1»
                        размещены ниже для клиентов и партнёров.
                    </p>

                </div>

                <div class="bg-white border border-gray-200 rounded-2xl overflow-hidden">

                    <RequisiteTable/>

                </div>

            </div>

        </section>

    </div>
</template>

<style scoped lang="scss">
</style>
